import React from 'react';
import { Input, Label } from 'reactstrap';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

class ControlledNumericInput extends React.Component {

    handleChange = (e) => {
        const { value } = e.target;
        this.props.setField(this.props.name, value);
        let isValidGrade
        if (e.target.value.length > this.props.maxLengthToUse)
            isValidGrade = false
        else
            isValidGrade = true
        this.props.disableSave(isValidGrade)
    }
    render() {
        const label = this.props.label ? <Label>{this.props.label}</Label> : null
        return (
            <React.Fragment>
                {label}
                <Input
                    name='controlledNumericInput'
                    type="number"
                    min={this.props.min || '1'}
                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                    max={this.props.max || '1000'} step={this.props.step || '1'}
                    onChange={this.handleChange} value={this.props.numberValue}
                    valid={this.props.isValid}
                    invalid={!this.props.isValid}
                />
            </React.Fragment>
        )
    }
}

export default ControlledNumericInput